<script setup lang="ts">
import KBadge from '@/components/badges/KBadge.vue';
import KTime from '@/components/times/KTime.vue';
import * as commonConstants from '@/constants/common';

export interface Props {
  id?: string;
  name?: string;
  datetime?: string;
  message?: string;
  isActive?: boolean;
  isRead?: boolean;
}
export type SmsChatMessagePreviewUnitProps = Props;

const props = withDefaults(defineProps<Props>(), {
  id: undefined,
  name: commonConstants.EM_DASH,
  datetime: undefined,
  message: commonConstants.EM_DASH,
  isActive: false,
  isRead: false,
});
</script>

<template>
  <article
    :class="[
      $style.smsChatMessagePreviewUnit,
      { [$style.active]: props.isActive },
    ]"
    data-testid="smsChatMessagePreviewUnit"
  >
    <header :class="$style.header">
      <KBadge
        location="left center"
        dot
        :color="props.isRead ? 'tertiary' : 'primary'"
      >
        <address :class="$style.name">{{ props.name }}</address>
      </KBadge>
      <KTime :datetime="props.datetime" :class="$style.time" />
    </header>
    <p :class="$style.message">
      {{ props.message }}
    </p>
  </article>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.smsChatMessagePreviewUnit {
  user-select: none;
  cursor: pointer;
  border-bottom: 1px solid colors.$color-gray-300;
  padding: 16px 16px 0 16px;

  &:hover {
    background-color: colors.$color-brand-50;
  }
  &.active,
  &:active {
    background-color: colors.$color-brand-100;
  }
  &.active:hover,
  &:active:hover {
    background-color: colors.$color-brand-200;
  }
}
  .header {
    font-size: 18px;
    display: flex;
    align-items: center;
  }
    .name {
      font-style: normal;
      margin-left: 14px;
    }
    .time {
      margin-left: auto;
      color: colors.$color-text-tertiary;
    }
  .message {
    margin-top: 8px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
